module.exports = __webpack_public_path__ + "img/undraw_Taking_notes_re_bnaf.6fbffd6b.svg";